import { Egg } from "lucide-react";
import { LitterBoard } from "./LitterBoard";
import { FollowBreederButton } from "./FollowBreederButton";
import { useLanguage } from "../../context/LanguageContext";
import { JourneyTip } from "./JourneyTip";

export const MemberLitters = ({ userId, mine }) => {
  const { t, lang } = useLanguage();
  return (
    <section id="litters" className="mt-8 scroll-mt-32" data-testid="profile-litters-section">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-1">
        <h2 className="font-display text-xl font-bold text-[#12234A] flex items-center gap-2"><Egg size={20} className="text-[#F5551E]" /> {t("lt_tab")}</h2>
        <FollowBreederButton breederId={userId} mine={mine} />
      </div>
      <p className="text-sm text-slate-500 mb-4">{t("lt_section_sub")}</p>
      <JourneyTip fr={lang === "fr"} />
      <LitterBoard breederId={userId} mine={mine} />
    </section>
  );
};
